import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Tengo que comprar comida cara?',
    a: 'No, usamos alimentos reales: huevos, carne, vegetales de estación y grasas buenas.'
  }, {
    q: '¿Hay que cocinar mucho?',
    a: 'No, las preparaciones son simples y rápidas para personas con poco tiempo.'
  }, {
    q: '¿Puedo tomar café?',
    a: 'Sí, dentro del protocolo te enseñamos cómo tomarlo para que no te inflame.'
  }, {
    q: '¿Es una dieta Keto?',
    a: 'Es un protocolo anti-inflamatorio. Es más flexible y sostenible que la dieta Keto estricta.'
  }, {
    q: '¿Cuándo recibo el material?',
    a: 'El acceso es inmediato tras el pago en formato PDF para leer en tu celular o tablet.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-stone-50" data-id="element-168">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-169">
        <div className="text-center mb-12" data-id="element-170">
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-4" data-id="element-171">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-172">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.1
        }} className="bg-white rounded-2xl border border-stone-200 overflow-hidden" data-id="element-173">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" aria-expanded={openIndex === index} data-id="element-174">
                <span className="font-semibold text-stone-900 text-lg pr-8" data-id="element-175">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-emerald-600 flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-176" />
              </button>
              <AnimatePresence data-id="element-177">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-178">
                    <div className="px-6 pb-5 text-stone-600" data-id="element-179">{faq.a}</div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}